/**
 * Reference to whether React app finished client-side hydration of serverside-created HTML.
 */
export const isAppHydratedRef = { current: false }
